module.exports = "<div *ngIf=\"type == 1\" [innerHTML]=\"text\"></div>\n<h4 *ngIf=\"type == 3\" [innerHTML]=\"text\"></h4>\n<p *ngIf=\"type == 2\" [innerHTML]=\"text\"></p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_directives/text.component.html
// module id = ./src/app/_directives/text.component.html
// module chunks = main